import script from "./WritingBoard.vue?vue&type=script&lang=ts&setup=true"
export * from "./WritingBoard.vue?vue&type=script&lang=ts&setup=true"

import "./WritingBoard.vue?vue&type=style&index=0&id=d8027742&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8027742"]])

export default __exports__